import axios from 'axios';
import { takeEvery, put, race, take, call, delay } from 'redux-saga/effects';
import { qcsSyncCreateResource } from 'data/qcsSyncResourceSagaHelpers';
import { mkQcsSyncResourceConfig } from 'data/qcsSyncResourceTypes';
import { mkDocument } from 'data/documents/types';
import { importData, importDataSuccess, importDataFailure, pfmImport, pfmImportSuccess, pfmImportFailure } from 'data/import/importActions';
import { createDocument, createDocumentSuccess, createDocumentFailure,
  getDocument, getDocumentSuccess, getDocumentFailure, deleteDocument } from 'data/documents/actions';
import { getTransactions } from 'data/transactions/actions';

export function* pfmImportActionWatcher() {
  const config = mkQcsSyncResourceConfig({
    resourceName: 'pfm-importer',
    resourceBaseUrl: '/pfm-importer/import?retry=true',
    getLastSyncDate: () => null,
    successAction: pfmImportSuccess,
    failureAction: pfmImportFailure,
    transformResourceWithResponse: (resource, response) => ({ ...resource, ...response }),
  });
  yield takeEvery(pfmImport, qcsSyncCreateResource, config);
}

export function* importDataActionWatcher() {
  yield takeEvery(importData, function* _importData(importDataAction) {

    yield put(createDocument(mkDocument(importDataAction.payload.document)));
    const { createDocumentSuccessAction, createDocumentFailureAction } = yield race({
      createDocumentSuccessAction: take((action) =>
        action.type === createDocumentSuccess.toString() && action.payload.clientId && action.payload.clientId === importDataAction.payload.document.clientId),
      createDocumentFailureAction: take((action) =>
        action.type === createDocumentFailure.toString() && action.payload.clientId && action.payload.clientId === importDataAction.payload.document.clientId),
    });

    if (createDocumentSuccessAction
      && createDocumentSuccessAction.payload.url
      && createDocumentSuccessAction.payload.contentType
      && createDocumentSuccessAction.payload.id
    ) {
      let dataUploadResponse;
      try {
        dataUploadResponse = yield call(axios.put, createDocumentSuccessAction.payload.url, importDataAction.payload.data, {headers: {'Content-Type': createDocumentSuccessAction.payload.contentType}});
      } catch (e) {
        yield put(importDataFailure({
          clientId: importDataAction.payload.clientId,
          ...e,
        }));
        return;
      }

      if (dataUploadResponse && dataUploadResponse.status === 200) {
        yield put(getDocument(mkDocument({ id: createDocumentSuccessAction.payload.id })));
        const { getDocumentSuccessAction, getDocumentFailureAction } = yield race({
          getDocumentSuccessAction: take((action) => action.type === getDocumentSuccess.toString()
              && action.payload.resources && action.payload.resources.length === 1
              && action.payload.resources[0].id === createDocumentSuccessAction.payload.id),
          getDocumentFailureAction: take((action) => action.type === getDocumentFailure.toString()
            && action.payload.resources && action.payload.resources.length === 1
            && action.payload.resources[0].id === createDocumentSuccessAction.payload.id),
        });

        const url = getDocumentSuccessAction && getDocumentSuccessAction.payload.resources && getDocumentSuccessAction.payload.resources.length === 1 && getDocumentSuccessAction.payload.resources[0].url;
        if (url) {
          yield put(pfmImport({
            clientId: importDataAction.payload.clientId,
            accountId: importDataAction.payload.accountId,
            url,
          }));
          const { pfmImportSuccessAction, pfmImportFailureAction } = yield race({
            pfmImportSuccessAction: take((action) => action.type === pfmImportSuccess.toString()
              && action.payload.clientId === importDataAction.payload.clientId),
            pfmImportFailureAction: take((action) => action.type === pfmImportFailure.toString()
              && action.payload.clientId === importDataAction.payload.clientId),
          });

          yield put(deleteDocument(mkDocument({ id: createDocumentSuccessAction.payload.id })));

          if (pfmImportSuccessAction) {
            yield put(importDataSuccess({
              clientId: importDataAction.payload.clientId,
              ...pfmImportSuccessAction.payload,
            }));

            // dirty hack - delete once websocket impelmented
            yield delay(3000);
            yield put(getTransactions(undefined, { context: 'import' }));
          } else {
            yield put(importDataFailure({
              clientId: importDataAction.payload.clientId,
              ...(pfmImportSuccessAction ? pfmImportSuccessAction.payload : pfmImportFailureAction.payload),
            }));
          }
        } else {
          yield put(importDataFailure({
            clientId: importDataAction.payload.clientId,
            ...(getDocumentSuccessAction ? getDocumentSuccessAction.payload : getDocumentFailureAction.payload),
          }));
        }
      } else {
        yield put(importDataFailure({
          clientId: importDataAction.payload.clientId,
          ...dataUploadResponse,
        }));
      }
    } else {
      yield put(importDataFailure({
        clientId: importDataAction.payload.clientId,
        ...(createDocumentFailureAction ? createDocumentFailureAction.payload : createDocumentSuccessAction.payload),
      }));
    }
  });

}

export default [
  importDataActionWatcher,
  pfmImportActionWatcher,
];
